import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'components/Modal/Modal';
import EditJobForm from './EditJobForm';
import styles from './EditJobModal.module.scss';

const EditJobModal = ({ brief, show, onClose, onSubmit, saving }) => {
  if (!brief) return null;

  return (
    <Modal
      show={show}
      onExit={onClose}
      closeButton
      modalClassName={styles.modal}
    >
      <div className={styles.modalContent}>
        <h2 className={styles.modalTitle}>Edit Job Details</h2>
        <EditJobForm
          brief={brief}
          saving={saving}
          onCancel={onClose}
          onSubmit={onSubmit}
          type="edit"
        />
      </div>
    </Modal>
  );
};

EditJobModal.propTypes = {
  brief: PropTypes.object,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  saving: PropTypes.bool,
};

EditJobModal.defaultProps = {
  saving: false,
};

export default EditJobModal;
